module.exports = __webpack_public_path__ + "static/media/support.be497c5e.png";